module.exports = __webpack_public_path__ + "school/img/chuang3jie.6b7de5c8.jpg";